import { defineMessages } from 'react-intl';
import Button from '@alltrails/shared/denali/components/Button';
import ProTag from '@alltrails/shared/components/ProTag';
import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';
import useMobileWidth from 'hooks/useMobileWidth';
import * as styles from './styles.module.scss';

const messages = defineMessages({
  PREVIEW_ROUTE: {
    defaultMessage: 'Preview route'
  }
});

type FlyoverEntryProps = {
  exploreFlag?: boolean;
  exactExplorePath: string;
  initializingFlyover?: boolean;
  onEntryClick?: () => void;
};

const FlyoverEntry = ({ exploreFlag, exactExplorePath, initializingFlyover = false, onEntryClick }: FlyoverEntryProps): JSX.Element => {
  const {
    formattedDefaultMessages: { PREVIEW_ROUTE }
  } = useFormatMessage(messages);

  const isMobileWidth = useMobileWidth();

  const flyoverParam = 'initFlyover=true';
  const flyoverHref = exactExplorePath.indexOf('?') === -1 ? `${exactExplorePath}?${flyoverParam}` : `${exactExplorePath}&${flyoverParam}`;
  const linkInfo = exploreFlag ? null : { href: flyoverHref };

  const onClick = () => {
    onEntryClick?.();
  };

  return (
    <div className={styles.flyoverContainer}>
      <Button
        loading={initializingFlyover}
        linkInfo={linkInfo}
        onClick={onClick}
        testId="flyover-entry"
        text={PREVIEW_ROUTE}
        size="sm"
        width={isMobileWidth || exploreFlag ? 'full' : 'auto'}
      />
      <ProTag className={styles.proTag} />
    </div>
  );
};

export default FlyoverEntry;
